import { PuzzleDto, PuzzleHeaderDto } from '../utils/types'
import apiClient from './api-client'

export const getPuzzles = async (): Promise<PuzzleHeaderDto[]> => {
    const res = await apiClient.get('/v1/puzzles')
    return res.data
}

export const getPuzzle = async (id: string): Promise<PuzzleDto> => {
    const res = await apiClient.get(`/v1/puzzles/${id}`)
    return res.data
}
